import React, { useState } from 'react';
import './Proceedtopayment.css';
import { api, ENDPOINTS } from '../../services/apiConfig';

const Proceedtopayment = () => {
  const [selectedCard, setSelectedCard] = useState('card1');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const handleCardSelect = (cardId) => {
    setSelectedCard(cardId);
  };
  
  const handleCheckout = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      // Get the JWT token from localStorage
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('Authentication token not found. Please log in again.');
      }
      
      // Create payload for the payment
      const payload = {
        paymentMethod: selectedCard === 'card1' ? 'card' : 'mobile_money'
      };
      
      // Make the API request to initiate transaction
      // The api.business.post already handles the headers and returns parsed data
      const data = await api.business.post(ENDPOINTS.business.makepayment, payload);
      
      // Check if data contains required information
      if (data && data.data && data.data.authorization_url) {
        // Log success message and redirect to payment gateway
        console.log('Payment initialized:', data);
        window.location.href = data.data.authorization_url;
      } else {
        throw new Error('Invalid response from payment server');
      }
      
    } catch (err) {
      console.error('Payment error:', err);
      // Handle different error types
      const errorMessage = err.data?.message || err.message || 'An error occurred while processing your payment';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="payment-container">
      {/* Background Video */}
      {/* <div className="video-background">
        <video autoPlay muted loop className="background-video">
          <source src="/assets/vendor-customer-video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay"></div>
      </div> */}
      
      <div className="payment-card">
        <div className="payment-logo-container">
          <img src="/assets/genie.png" alt="Genie Logo" className="login-logo" />
        </div>
        
        <div className="payment-header">
          <h2>Complete Your Payment</h2>
          <p className="payment-subtitle">You'll be redirected to our secure payment gateway</p>
        </div>
        
        <div className="payment-method-section">
          <h3>All Payment Methods Available at Checkout</h3>
        
          
          {/* Mobile Money */}
          <div 
            className={`card-option ${selectedCard === 'card2' ? 'selected' : ''}`}
            onClick={() => handleCardSelect('card2')}
          >
            <div className="card-info">
              <div className="card-logo momo">
                <div className="circle yellow"></div>
                <div className="circle red"></div>
              </div>
              <div className="card-details">
                <div className="card-number">All Payments Type</div>
                <div className="card-name">Available</div>
              </div>
            </div>
            <div className="card-expiry">Instant</div>
          </div>
        </div>
        
        {error && (
          <div className="payment-error">
            <p>{error}</p>
          </div>
        )}
        
        <div className="secure-payment-info">
          <div className="secure-icon">🔒</div>
          <p>Secure payment processing via Paystack. Your financial details are encrypted and secure.</p>
        </div>
        
        {/* Checkout button */}
        <button 
          className="checkout-button"
          onClick={handleCheckout}
          disabled={isLoading}
        >
          {isLoading ? 'Processing...' : 'Proceed to Payment'}
        </button>
        
        <div className="payment-footer">
          <p>By completing this subscription, you agree to our <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy Policy</a></p>
        </div>
      </div>
    </div>
  );
};

export default Proceedtopayment;